import ProjectPage from "../../components/ProjectPage";

// To add a real screenshot: drop the file into src/assets/, import it here
// (e.g. `import shot from "../../assets/jobmatch-dashboard.png";`), then add
// `src: shot` to the matching frame below.
export default function Jobmatch() {
  return (
    <ProjectPage
      title="JobMatch"
      category="Web"
      tagline="Connecting candidates with jobs from Profesia."
      body={[
        "JobMatch scrapes and parses job listings from profesia.sk, reads your uploaded resume, and matches you with the roles that actually fit your skills and experience.",
        "Instead of endless scrolling through listings, you get a ranked shortlist built from what's really in your CV.",
      ]}
      art="linear-gradient(155deg, rgba(var(--text-rgb), 0.17) 0%, rgba(var(--accent-rgb), 0.08) 60%, rgba(var(--text-rgb), 0.02) 100%)"
      // tech + features are draft copy — edit freely
      tech={["Python", "Web scraping", "Resume parsing", "React", "REST API"]}
      features={[
        {
          title: "Automated listing scraping",
          desc: "Pulls fresh job listings from profesia.sk and normalizes them for matching.",
        },
        {
          title: "Resume upload & parsing",
          desc: "Reads your CV and extracts skills and experience automatically.",
        },
        {
          title: "Skill-overlap match scoring",
          desc: "Scores every listing against what's actually in your resume.",
        },
        {
          title: "Ranked shortlist",
          desc: "A focused list of best-fit roles instead of endless scrolling.",
        },
      ]}
      github="https://github.com/olisekw/jobmatch"
      frames={[
        { type: "web", label: "Dashboard — screenshot coming" },
        { type: "web", label: "Matches — screenshot coming" },
      ]}
    />
  );
}
